/* eslint-disable max-lines, complexity */
import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';
import _snakeCase from 'lodash.snakecase';
import { StatusCodes } from 'http-status-codes';

import logger from 'logger';
import ApiService from 'services/ApiService/ApiService';
import NotificationService from 'services/NotificationService';
import httpStatusCodes from 'enum/httpStatusCodes';
import makeAction from 'utils/makeAction';
import parseCatch from 'utils/parseCatch';

import {
  ACCOUNT_PERMISSION_URL,
  CASHOUT_IDENTITIES_URL,
  GET_ACCOUNT_IDENTITY_URL,
  GET_ADDITIONAL_IDENTITIES_URL,
  GET_CASHOUT_IDENTITY_STATUS_URL,
  GET_CASHOUT_UPDATE_IDENTITY_URL,
  GET_REMOVE_PERFORMER_URL,
  GET_REMOVE_SECURITY_LOG_URL,
  GET_ROSTER_URL,
  GET_STAFF_NOTES_URL,
  GET_UPDATE_ACCOUNT_URL,
  IDENTITIES_URL,
  SECURITY_LOG_URL,
  SPAM_MESSAGES_IP_SUMMARY,
  SPAM_MESSAGES_RECIPIENT_SUMMARY,
  SPAM_MESSAGES_SCORE_URL,
  SPAM_MESSAGES_SUMMARY_URL,
  SPAM_MESSAGES_URL,
  SPAM_MESSAGES_USER_SUMMARY_URL,
  TOTAL_COUNTS_CASHOUT_URL,
  TOTAL_COUNTS_IDENTITIES_URL,
  WATCHLIST_TOTAL_COUNT_URL,
  WATCHLIST_URL,
} from './Api';


const SET_APPROVAL_2257_IDENTITIES = 'cam4/admin/SET_APPROVAL_2257_IDENTITIES';
const SET_CASH_OUT_APPROVAL_ACCOUNTS = 'cam4/admin/SET_CASH_OUT_APPROVAL_ACCOUNTS';
const SET_WATCHLIST_IDENTITIES = 'cam4/admin/SET_WATCHLIST_IDENTITIES';
const TOGGLE_ACO_STATUS_IDENTITIES = 'cam4/admin/TOGGLE_ACO_STATUS_IDENTITIES';
const UPDATE_ACCOUNT_ON_WATCH = 'cam4/admin/UPDATE_ACCOUNT_ON_WATCH';
const SET_ACCOUNT_DETAILS = 'cam4/admin/SET_ACCOUNT_DETAILS';
const SET_SUPER_ADMIN = 'cam4/admin/SET_SUPER_ADMIN';
const SET_STAFF_NOTES = 'cam4/admin/SET_STAFF_NOTES';
const SET_ADDITIONAL_IDENTITIES = 'cam4/admin/SET_ADDITIONAL_IDENTITIES';
const SET_IDENTITIES_TOTAL_COUNTS = 'cam4/admin/SET_IDENTITIES_TOTAL_COUNTS';
const SET_CASH_OUT_APPROVAL_TOTAL_COUNTS = 'cam4/admin/SET_CASH_OUT_APPROVAL_TOTAL_COUNTS';
const SET_WATCHLIST_TOTAL_COUNT = 'cam4/admin/SET_WATCHLIST_TOTAL_COUNT';
const SET_CASHOUT_STATUS = 'cam4/admin/SET_CASHOUT_STATUS';
const SET_ROSTER = 'cam4/admin/SET_ROSTER';
const GET_SPAMERS = 'cam4/admin/GET_SPAMERS';
const GET_SPAMERS_COUNT = 'cam4/admin/GET_SPAMERS_COUNT';
const GET_SPAM_DETAILS = 'cam4/admin/GET_SPAM_DETAILS';
const GET_SPAM_DETAILS_COUNT = 'cam4/admin/GET_SPAM_DETAILS_COUNT';
const GET_SPAM_MESSAGE_SCORE = 'cam4/admin/GET_SPAM_MESSAGE_SCORE';
const GET_SPAM_MESSAGES = 'cam4/admin/GET_SPAM_MESSAGES';
const GET_SPAM_MESSAGES_COUNT = 'cam4/admin/GET_SPAM_MESSAGES_COUNT';
const GET_USER_MESSAGES = 'cam4/admin/GET_USER_MESSAGES';
const GET_USER_MESSAGES_COUNT = 'cam4/admin/GET_USER_MESSAGES_COUNT';
const REMOVE_PERFORMER = 'cam4/admin/REMOVE_PERFORMER';
const SET_SECURITY_LOG_IDENTITIES = 'cam4/admin/SET_SECURITY_LOG_IDENTITIES';
const SET_SECURITY_LOG_TABLE_PAGE = 'cam4/admin/SET_SECURITY_LOG_TABLE_PAGE';
const SET_SECURITY_LOG_TOTAL_COUNT = 'cam4/admin/SET_SECURITY_LOG_TOTAL_COUNT';
const GET_SPAM_MESSAGE_IP_SUMMARY = 'cam4/admin/GET_SPAM_MESSAGE_IP_SUMMARY';
const GET_SPAM_MESSAGE_IP_SUMMARY_COUNT = 'cam4/admin/GET_SPAM_MESSAGE_IP_SUMMARY_COUNT';
const GET_SPAM_MESSAGES_RECIPIENT_SUMMARY = 'cam4/admin/GET_SPAM_MESSAGES_RECIPIENT_SUMMARY';
const GET_SPAM_MESSAGES_RECIPIENT_SUMMARY_COUNT = 'cam4/admin/GET_SPAM_MESSAGES_RECIPIENT_SUMMARY_COUNT';

const initialState = Immutable.fromJS({
  approval2257Identities: {
    content: [],
    totalElements: 0,
    loading: true,
  },
  cashOutApprovalAccounts: [],
  cashoutStatus: {},
  watchlistIdentities: {
    content: [],
    totalElements: 0,
  },
  securityLogIdentities: [],
  identitiesTotalCounts: {
    performerPending: 0,
    performerPendingNeedsId: 0,
    studioOwnerAndAdmins: 0,
    studioPerformers: 0,
    studioPerformersNeedsId: 0,
  },
  cashOutApprovalTotalCounts: {
    perfomerCashout: 0,
    studioOwnerAndAdminsCashout: 0,
    studioPerformersCashout: 0,
  },
  watchlistTotalCount: 0,
  securityLogTablePage: 0,
  securityLogTotalCount: 0,
  accountDetails: {},
  isSuperAdmin: false,
  staffNotes: [],
  additionalIdentities: [],
  roster: [],
  spamers: [],
  spammersCount: 0,
  spamDetails: [],
  spamDetailsCount: 0,
  spamMessages: [],
  spamMessagesCount: 0,
  spamMessageScore: 0,
  tempSpamMessageScore: 0,
  userMessages: [],
  userMessagesCount: 0,
  spamMessageIpSummary: [],
  spamMessageIpSummaryCount: 0,
  spamMessageRecipientSummary: [],
  spamMessageRecipientSummaryCount: 0,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_APPROVAL_2257_IDENTITIES:
      return state.set('approval2257Identities', Immutable.fromJS(action.identities));
    case SET_CASH_OUT_APPROVAL_ACCOUNTS:
      return state.set('cashOutApprovalAccounts', Immutable.fromJS(action.accounts));
    case SET_WATCHLIST_IDENTITIES:
      return state.set('watchlistIdentities', Immutable.fromJS(action.identities));
    case TOGGLE_ACO_STATUS_IDENTITIES:
      return state.setIn(['accountDetails', 'ableToCashOut'], Immutable.fromJS(action.ableToCashOut));
    case SET_ACCOUNT_DETAILS:
      return state.set('accountDetails', Immutable.fromJS(action.details));
    case UPDATE_ACCOUNT_ON_WATCH:
      return state.setIn(['accountDetails', 'onWatch'], action.onWatch);
    case SET_SUPER_ADMIN:
      return state.set('isSuperAdmin', action.isSuperAdmin);
    case SET_STAFF_NOTES:
      return state.set('staffNotes', Immutable.fromJS(action.staffNotes));
    case SET_ADDITIONAL_IDENTITIES:
      return state.set('additionalIdentities', Immutable.fromJS(action.identities));
    case SET_IDENTITIES_TOTAL_COUNTS:
      return state.set('identitiesTotalCounts', Immutable.fromJS(action.identitiesTotalCounts));
    case SET_CASH_OUT_APPROVAL_TOTAL_COUNTS:
      return state.set('cashOutApprovalTotalCounts', Immutable.fromJS(action.cashOutApprovalTotalCounts));
    case SET_WATCHLIST_TOTAL_COUNT:
      return state.set('watchlistTotalCount', Immutable.fromJS(action.watchlistTotalCount));
    case SET_CASHOUT_STATUS:
      return state.set('cashoutStatus', Immutable.fromJS(action.cashoutStatus));
    case SET_ROSTER:
      return state.set('roster', Immutable.fromJS(action.roster));
    case GET_SPAMERS_COUNT:
      return state.set('spamersCount', Immutable.fromJS(action.spamersCount));
    case GET_SPAMERS:
      return state.set('spamers', Immutable.fromJS(action.spamers));
    case GET_SPAM_MESSAGE_SCORE:
      return state.set('spamMessageScore', Immutable.fromJS(action.spamMessageScore));
    case GET_SPAM_MESSAGES:
      return state.set('spamMessages', Immutable.fromJS(action.spamMessages));
    case GET_SPAM_MESSAGES_COUNT:
      return state.set('spamMessagesCount', Immutable.fromJS(action.spamMessagesCount));
    case GET_USER_MESSAGES:
      return state.set('userMessages', Immutable.fromJS(action.userMessages));
    case GET_USER_MESSAGES_COUNT:
      return state.set('userMessagesCount', Immutable.fromJS(action.userMessagesCount));
    case GET_SPAM_DETAILS:
      return state.set('spamDetails', Immutable.fromJS(action.spamDetails));
    case GET_SPAM_DETAILS_COUNT:
      return state.set('spamDetailsCount', Immutable.fromJS(action.spamDetailsCount));
    case REMOVE_PERFORMER:
      return state.set(
        'roster',
        state.get('roster').filter((perf) => perf.get('username') !== action.performer)
      );
    case SET_SECURITY_LOG_IDENTITIES:
      return state.set('securityLogIdentities', Immutable.fromJS(action.securityLogIdentities));
    case SET_SECURITY_LOG_TABLE_PAGE:
      return state.set('securityLogTablePage', Immutable.fromJS(action.securityLogTablePage));
    case SET_SECURITY_LOG_TOTAL_COUNT:
      return state.set('securityLogTotalCount', Immutable.fromJS(action.securityLogTotalCount));
    case GET_SPAM_MESSAGE_IP_SUMMARY:
      return state.set('spamMessageIpSummary', Immutable.fromJS(action.getSpamMessageIpSummary));
    case GET_SPAM_MESSAGES_RECIPIENT_SUMMARY:
      return state.set('spamMessageRecipientSummary', Immutable.fromJS(action.getSpamMessageRecipientSummary));
    default:
      return state;
  }
}

export const NAME = 'adminDashboard';

// Selectors
const approval2257Identities = (state) => state[NAME].get('approval2257Identities');
const cashOutApprovalAccounts = (state) => state[NAME].get('cashOutApprovalAccounts');
const cashoutStatus = (state) => state[NAME].get('cashoutStatus');
const watchlistIdentities = (state) => state[NAME].get('watchlistIdentities');
const identitiesTotalCounts = (state) => state[NAME].get('identitiesTotalCounts');
const cashOutApprovalTotalCounts = (state) => state[NAME].get('cashOutApprovalTotalCounts');
const accountDetails = (state) => state[NAME].get('accountDetails');
const isSuperAdmin = (state) => state[NAME].get('isSuperAdmin');
const staffNotes = (state) => state[NAME].get('staffNotes');
const additionalIdentities = (state) => state[NAME].get('additionalIdentities');
const watchlistTotalCount = (state) => state[NAME].get('watchlistTotalCount');
const roster = (state) => state[NAME].get('roster');
const spammers = (state) => state[NAME].get('spamers');
const spammersCount = (state) => state[NAME].get('spamersCount');
const spamDetails = (state) => state[NAME].get('spamDetails');
const spamDetailsCount = (state) => state[NAME].get('spamDetailsCount');
const spamMessages = (state) => state[NAME].get('spamMessages');
const spamMessagesCount = (state) => state[NAME].get('spamMessagesCount');
const spamMessageScore = (state) => state[NAME].get('spamMessageScore');
const userMessages = (state) => state[NAME].get('userMessages');
const userMessagesCount = (state) => state[NAME].get('userMessagesCount');
const securityLogIdentities = (state) => state[NAME].get('securityLogIdentities');
const securityLogTablePage = (state) => state[NAME].get('securityLogTablePage');
const securityLogTotalCount = (state) => state[NAME].get('securityLogTotalCount');
const spamMessageIpSummary = (state) => state[NAME].get('spamMessageIpSummary');
const spamMessageIpSummaryCount = (state) => state[NAME].get('spamMessageIpSummaryCount');
const spamMessageRecipientSummary = (state) => state[NAME].get('spamMessageRecipientSummary');
const spamMessageRecipientSummaryCount = (state) => state[NAME].get('spamMessageRecipientSummaryCount');

// Actions
const setApproval2257Identities = makeAction(SET_APPROVAL_2257_IDENTITIES, 'identities');
const setCashOutApprovalAccounts = makeAction(SET_CASH_OUT_APPROVAL_ACCOUNTS, 'accounts');
const setWatchlistIdentities = makeAction(SET_WATCHLIST_IDENTITIES, 'identities');
const setAccountDetails = makeAction(SET_ACCOUNT_DETAILS, 'details');
const setStaffNotes = makeAction(SET_STAFF_NOTES, 'staffNotes');
const setIdentitiesTotalCounts = makeAction(SET_IDENTITIES_TOTAL_COUNTS, 'identitiesTotalCounts');
const setCashOutApprovalTotalCounts = makeAction(SET_CASH_OUT_APPROVAL_TOTAL_COUNTS, 'cashOutApprovalTotalCounts');
const setAdditionalIdentities = makeAction(SET_ADDITIONAL_IDENTITIES, 'identities');
const setCashoutStatus = makeAction(SET_CASHOUT_STATUS, 'cashoutStatus');
const updateAccountOnWatch = makeAction(UPDATE_ACCOUNT_ON_WATCH, 'onWatch');
const setSuperAdmin = makeAction(SET_SUPER_ADMIN, 'isSuperAdmin');
const setWatchlistTotalCount = makeAction(SET_WATCHLIST_TOTAL_COUNT, 'watchlistTotalCount');
const setRoster = makeAction(SET_ROSTER, 'roster');
const removePerformer = makeAction(REMOVE_PERFORMER, 'performer');
const getSpammers = makeAction(GET_SPAMERS, 'spamers');
const getSpammersCount = makeAction(GET_SPAMERS_COUNT, 'spamersCount');
const getSpamDetails = makeAction(GET_SPAM_DETAILS, 'spamDetails');
const getSpamMessageScore = makeAction(GET_SPAM_MESSAGE_SCORE, 'spamMessageScore');
const getUserMessages = makeAction(GET_USER_MESSAGES, 'userMessages');
const getUserMessagesCount = makeAction(GET_USER_MESSAGES_COUNT, 'userMessagesCount');
const getSpamMessages = makeAction(GET_SPAM_MESSAGES, 'spamMessages');
const getSpamMessagesCount = makeAction(GET_SPAM_MESSAGES_COUNT, 'spamMessagesCount');
const setSecurityLogIdentities = makeAction(SET_SECURITY_LOG_IDENTITIES, 'securityLogIdentities');
const setSecurityLogTablePage = makeAction(SET_SECURITY_LOG_TABLE_PAGE, 'securityLogTablePage');
const setSecurityLogTotalCount = makeAction(SET_SECURITY_LOG_TOTAL_COUNT, 'securityLogTotalCount');
const getSpamMessagesIpSummary = makeAction(GET_SPAM_MESSAGE_IP_SUMMARY, 'getSpamMessageIpSummary');
const getspamMessageIpSummaryCount = makeAction(GET_SPAM_MESSAGE_IP_SUMMARY_COUNT, 'spamMessageIpSummaryCount');
const getSpamMessageRecipientSummary = makeAction(
  GET_SPAM_MESSAGES_RECIPIENT_SUMMARY,
  'getSpamMessageRecipientSummary'
);
const getSpamMessageRecipientSummaryCount = makeAction(
  GET_SPAM_MESSAGES_RECIPIENT_SUMMARY_COUNT,
  'getSpamMessageRecipientSummaryCount'
);

function getSecurityLogIdentities(filters = {}) {
  const offset = filters.page * filters.perPage;

  // this is the only correct way for query to work
  // if it's written as query string, it won't
  const queryParams = {
    sortDirection: filters.order.toUpperCase(),
    offset,
    limit: filters.perPage,
    sortBy: _snakeCase(filters.sortBy).toUpperCase(),
  };

  return (dispatch) =>
    ApiService.get(SECURITY_LOG_URL, { params: queryParams })
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          dispatch(setSecurityLogTablePage(filters.page));
          dispatch(setSecurityLogIdentities(res.data.securityLogs));
          dispatch(setSecurityLogTotalCount(res.data.totalSize));
        } else {
          logger.warn({ msg: 'getSecurityLogIdentities:', error: res.status });
        }
      })
      .catch((error) => {
        parseCatch(error, true);
      });
}

function deleteSecurityLogIdentity(id, page, sortOrder) {
  return (dispatch) =>
    ApiService.delete(GET_REMOVE_SECURITY_LOG_URL(id))
      .then((res) => {
        if (res.status === StatusCodes.NO_CONTENT) {
          dispatch(
            getSecurityLogIdentities({
              page,
              order: sortOrder,
              perPage: 20,
              sortBy: 'date_added',
            })
          );
        } else {
          logger.warn({ msg: 'deleteSecurityLogIdentity:', error: res.status });
        }
      })
      .catch((error) => {
        parseCatch(error, true);
      });
}

function fetchApproval2257Identities({ username, accessHash }, filters, pagination) {
  const queryParams = new URLSearchParams();
  const { completionStatus, identityTypeFilter, needsId, status, accountType, country } = filters;
  queryParams.append('completionStatus', completionStatus);
  queryParams.append('identityTypeFilter', identityTypeFilter);
  queryParams.append('needsId', needsId);
  queryParams.append('country', country);
  status.forEach((item) => queryParams.append('status', item));
  accountType.forEach((item) => queryParams.append('accountType', item));

  const { page, perPage, order, orderBy } = pagination;
  queryParams.append('page', page);
  queryParams.append('size', perPage);
  queryParams.append('direction', order.toUpperCase());
  queryParams.append('sortBy', _snakeCase(orderBy).toUpperCase());

  const config = {
    headers: { username, accessHash },
    params: queryParams,
    withCredentials: false,
  };

  return (dispatch) =>
    ApiService.get(IDENTITIES_URL, config)
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          const { data } = res;
          data.loading = false;
          dispatch(setApproval2257Identities(data));
        } else {
          logger.warn({ msg: 'fetchApproval2257Identities:', error: res.status });
        }
      })
      .catch((error) => {
        parseCatch(error, true);
      });
}

function resetApproval2257Identities() {
  return (dispatch) => dispatch(setApproval2257Identities(initialState.get('approval2257Identities')));
}

function fetchCashOutApprovalAccounts({ username, accessHash }, filters, pagination) {

  const queryParams = new URLSearchParams();
  const { accountType } = filters;
  const { page, perPage, order, orderBy } = pagination;

  accountType.forEach((item) => queryParams.append('accountType', item));
  queryParams.append('page', page);
  queryParams.append('size', perPage);
  queryParams.append('direction', order.toUpperCase());
  queryParams.append('sortBy', _snakeCase(orderBy).toUpperCase());


  const config = {
    headers: { username, accessHash },
    params: queryParams,
    withCredentials: false,
  };

  return (dispatch) =>
    ApiService.get(CASHOUT_IDENTITIES_URL, config)
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          dispatch(setCashOutApprovalAccounts(res.data));
        } else {
          logger.warn({ msg: 'fetchCashOutApprovalAccounts:', error: res.status });
        }
      })
      .catch((error) => {
        parseCatch(error, true);
      });
}

function resetCashOutApprovalAccounts() {
  return (dispatch) => dispatch(setCashOutApprovalAccounts(initialState.get('cashOutApprovalAccounts')));
}

function resetAccountDetails() {
  return (dispatch) => {
    dispatch(setAccountDetails(initialState.get('accountDetails')));
    dispatch(setStaffNotes(initialState.get('staffNotes')));
    dispatch(setAdditionalIdentities(initialState.get('additionalIdentities')));
  };
}

function fetchSuperAdmin(username, accessHash) {

  return (dispatch) =>
    ApiService.get(ACCOUNT_PERMISSION_URL, { headers: { username, accessHash }, withCredentials: false })
      .then((res) => {
        const isSuperAdmin = res.status === StatusCodes.NO_CONTENT;
        dispatch(setSuperAdmin(isSuperAdmin));
      });
}

function getWatchlistIdentities(pagination = {}, user) {
  const config = {
    headers: { username: user.username, accessHash: user.accessHash },
    params: {
      direction: pagination.order.toUpperCase(),
      page: pagination.page,
      size: pagination.perPage,
      sortBy: _snakeCase(pagination.orderBy).toUpperCase(),
    },
    withCredentials: false,
  };

  return (dispatch) =>
    ApiService.get(encodeURI(WATCHLIST_URL), config)
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          dispatch(setWatchlistIdentities(res.data));
        } else {
          logger.warn({ msg: 'getWatchlistIdentities:', error: res.status });
        }
      })
      .catch((error) => {
        parseCatch(error, true);
      });
}

function getStaffNotes(accountUsername, filters, user, showHundred = true) {

  const URL = encodeURI(GET_STAFF_NOTES_URL(accountUsername));

  const config = {
    headers: { username: user.username, accessHash: user.accessHash },
    params: {
      page: filters.page,
      size: showHundred ? 100 : filters.perPage,
    },
    withCredentials: false,
  };

  return (dispatch) =>
    ApiService.get(URL, config)
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          dispatch(setStaffNotes(res.data));
        } else {
          logger.warn({ msg: 'getStaffNotes:', error: res.status });
        }
      })
      .catch((error) => {
        parseCatch(error, true);
      });
}

function getAdditionalIdentities(accountUsername, identityType, user) {
  const URL = encodeURI(GET_ADDITIONAL_IDENTITIES_URL(accountUsername));

  const config = {
    headers: { username: user.username, accessHash: user.accessHash },
    params: {
      page: 0,
      size: 100,
      toExclude: identityType,
    },
    withCredentials: false,
  };

  return (dispatch) =>
    ApiService.get(URL, config)
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          dispatch(setAdditionalIdentities(res.data));
        } else {
          logger.warn({ msg: 'getAdditionalIdentities:', error: res.status });
        }
      })
      .catch((error) => {
        parseCatch(error, true);
      });
}

function getAccountDetails(accountUsername, identityType, user) {

  const URL = encodeURI(GET_ACCOUNT_IDENTITY_URL(accountUsername, identityType));
  const headers = {
    username: user.username,
    accessHash: user.accessHash,
  };

  return (dispatch) =>
    ApiService.get(URL, { headers, withCredentials: false })
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          dispatch(setAccountDetails(res.data));
          dispatch(getStaffNotes(accountUsername, { page: 0, perPage: 5 }, user));
          dispatch(getAdditionalIdentities(accountUsername, identityType, user));
        } else {
          logger.warn({ msg: 'getAccountDetails:', error: res.status });
        }
      })
      .catch((error) => {
        resetAccountDetails(dispatch);
        // eslint-disable-next-line no-alert
        alert(`getAccountDetails error' ${JSON.stringify(httpStatusCodes[error.response.status])}`);
        parseCatch(error, true);
      });
}

function updateAccountStatus(accountUsername, identityType, status, user) {

  const URL = encodeURI(GET_ACCOUNT_IDENTITY_URL(accountUsername, identityType));

  const config = {
    data: { status },
    headers: { username: user.username, accessHash: user.accessHash },
    withCredentials: false,
  };

  return (dispatch) =>
    ApiService.patch(URL, config)
      .then((res) => {
        if ([StatusCodes.OK, StatusCodes.NO_CONTENT].includes(res.status)) {
          dispatch(getAccountDetails(accountUsername, identityType, user));
        } else {
          logger.warn({ msg: 'getAccountDetails:', error: res.status });
        }
      })
      .catch((error) => {
        parseCatch(error, true);
      });
}

function getCashoutStatus(username) {

  const URL = GET_CASHOUT_IDENTITY_STATUS_URL(encodeURIComponent(username));

  return (dispatch) =>
    ApiService.get(URL)
      .then((res) => dispatch(setCashoutStatus(res.data)))
      .catch((error) => {
        parseCatch(error, true);
      });
}

function getIdentitiesTotalCounts({ username, accessHash }) {

  const config = {
    params: { status: 'PENDING_APPROVAL' },
    headers: { username, accessHash },
    withCredentials: false,
  };

  return (dispatch) => {
    ApiService.get(TOTAL_COUNTS_IDENTITIES_URL, config)
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          const { countByCategories } = res.data;
          const noNeedsIdCompleteCount = countByCategories?.DOESNT_NEED_ID?.COMPLETE;
          const needsIdCompleteCount = countByCategories?.NEEDS_ID?.COMPLETE;
          const performerPendingComplete = noNeedsIdCompleteCount?.PERFORMER || 0;
          const performerPendingNeedsIdComplete = needsIdCompleteCount?.PERFORMER || 0;
          const studioOwnerCount = noNeedsIdCompleteCount?.STUDIO_OWNER || 0;
          const studioAdminCount = noNeedsIdCompleteCount?.STUDIO_ADMIN || 0;
          const studioPerformersComplete = noNeedsIdCompleteCount?.STUDIO_PERFORMER || 0;
          const studioPerformersNeedsIdComplete = needsIdCompleteCount?.STUDIO_PERFORMER || 0;
          const counts = {
            performerPending: performerPendingComplete,
            performerPendingNeedsId: performerPendingNeedsIdComplete,
            studioOwnerAndAdmins: studioOwnerCount + studioAdminCount,
            studioPerformers: studioPerformersComplete,
            studioPerformersNeedsId: studioPerformersNeedsIdComplete,
          };
          dispatch(setIdentitiesTotalCounts(counts));
        }
      })
      .catch((error) => {
        parseCatch(error, true);
      });
  };
}

function getCashOutApprovalTotalCounts({ username, accessHash }) {

  return (dispatch) => {
    ApiService.get(TOTAL_COUNTS_CASHOUT_URL, { headers: { username, accessHash }, withCredentials: false })
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          const responseCounts = res.data.counts;
          const performerCount = responseCounts?.PERFORMER?.SHOW || 0;
          const studioOwnerCount = responseCounts?.STUDIO_OWNER?.SHOW || 0;
          const studioAdminCount = responseCounts?.STUDIO_ADMIN?.SHOW || 0;
          const studioPerformerCount = responseCounts?.STUDIO_PERFORMER?.SHOW || 0;
          const counts = {
            perfomerCashout: performerCount,
            studioOwnerAndAdminsCashout: studioOwnerCount + studioAdminCount,
            studioPerformersCashout: studioPerformerCount,
          };
          dispatch(setCashOutApprovalTotalCounts(counts));
        }
      })
      .catch((error) => {
        parseCatch(error, true);
      });
  };
}

function updateCashoutStatus(user, accountUsername, approveOrReject, identityType) {

  const URL = GET_CASHOUT_UPDATE_IDENTITY_URL(encodeURIComponent(accountUsername));

  const config = {
    data: { approved: approveOrReject },
    headers: { username: user.username, accessHash: user.accessHash },
    withCredentials: false,
  };

  return (dispatch) =>
    ApiService.patch(URL, config)
      .then(() => {
        dispatch(getStaffNotes(accountUsername, { page: 0, perPage: 5 }, user));
        dispatch(getCashoutStatus(accountUsername));
        dispatch(getAccountDetails(accountUsername, identityType, user));
      })
      .catch((error) => {
        parseCatch(error, true);
      });
}

function getWatchlistTotalCount({ username, accessHash }) {
  return (dispatch) =>
    ApiService.get(
      WATCHLIST_TOTAL_COUNT_URL,
      { headers: { username, accessHash }, withCredentials: false }
    )
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          const { count } = res.data;
          dispatch(setWatchlistTotalCount(count));
        }
      })
      .catch((error) => {
        parseCatch(error, true);
      });
}

function updateOnWatchStatus(data) {

  const { user, onWatch, accountUsername } = data;
  const URL = GET_UPDATE_ACCOUNT_URL(accountUsername);

  const config = {
    data: { onWatch: !onWatch },
    headers: { username: user.username, accessHash: user.accessHash },
    withCredentials: false,
  };

  return (dispatch) =>
    ApiService.patch(URL, config)
      .then((res) => {
        if ([StatusCodes.OK, StatusCodes.NO_CONTENT].includes(res.status)) {
          dispatch(updateAccountOnWatch(!data.onWatch));
          dispatch(getWatchlistTotalCount(user));
        } else {
          logger.warn({ msg: 'updateOnWatchStatus:', error: res.status });
        }
      })
      .catch((error) => {
        parseCatch(error, true);
      });
}

function getRoster(studioOwnerName) {

  const URL = GET_ROSTER_URL(studioOwnerName);

  return (dispatch) =>
    ApiService.get(URL)
      .then((res) => {
        dispatch(setRoster(res.data));
      })
      .catch(({ status }) => {
        if (status === StatusCodes.NOT_FOUND) {
          NotificationService.create({
            type: NotificationService.type.TOAST,
            subtype: NotificationService.subtype.ERROR,
            text: 'The user that you are searching for is not a studio owner.',
          });
        } else {
          NotificationService.create({
            type: NotificationService.type.TOAST,
            subtype: NotificationService.subtype.ERROR,
            text: 'Failed to retrieve the studio roster.',
          });
        }
      });
}

function releasePerformer(studioOwnerName, performerName) {
  const URL = GET_REMOVE_PERFORMER_URL(studioOwnerName, performerName);

  return (dispatch) =>
    ApiService.delete(URL)
      .then(() => {
        dispatch(removePerformer(performerName));
        NotificationService.create({
          type: NotificationService.type.TOAST,
          subtype: NotificationService.subtype.SUCCESS,
          text: 'Performer released from studio.',
        });
      })
      .catch(({ status }) => {
        if (status === StatusCodes.NOT_FOUND) {
          NotificationService.create({
            type: NotificationService.type.TOAST,
            subtype: NotificationService.subtype.ERROR,
            text: 'The user is no longer part of the studio.',
          });
        } else {
          NotificationService.create({
            type: NotificationService.type.TOAST,
            subtype: NotificationService.subtype.ERROR,
            text: 'Failed to release the studio performer.',
          });
        }
      });
}

function getSpamMessagesData(queryParams = {}) {
  const URL = SPAM_MESSAGES_URL;

  return (dispatch) =>
    ApiService.get(URL, { params: queryParams })
      .then((response) => {
        dispatch(getSpamMessages(response.data.entries));
        dispatch(getSpamMessagesCount(response.data.totalSize));
      })
      .catch((err) => {
        NotificationService.create({
          type: NotificationService.type.TOAST,
          subtype: NotificationService.subtype.ERROR,
          text: `${URL} failed with: ${err}`,
        });
        dispatch(getSpamMessages([]));
      });
}

function getSpammersData(queryParams = {}) {
  const URL = SPAM_MESSAGES_SUMMARY_URL;

  return (dispatch) =>
    ApiService.get(URL, { params: queryParams })
      .then((response) => {
        dispatch(getSpammers(response.data.entries));
        dispatch(getSpammersCount(response.data.totalSize));
      })
      .catch((err) => {
        NotificationService.create({
          type: NotificationService.type.TOAST,
          subtype: NotificationService.subtype.ERROR,
          text: `${URL} failed with: ${err}`,
        });
        dispatch(getSpammers([]));
      });
}

function getSpamDetailsData(messageHashed, chatType) {

  const URL = SPAM_MESSAGES_USER_SUMMARY_URL;

  return (dispatch) =>
    ApiService.get(URL, { params: { messageHashed, chatType } })
      .then((response) => {
        dispatch(getSpamDetails(response.data));
      })
      .catch((err) => {
        NotificationService.create({
          type: NotificationService.type.TOAST,
          subtype: NotificationService.subtype.ERROR,
          text: `${URL} failed with: ${err}`,
        });
        dispatch(getSpamDetails([]));
      });
}
function getUserMessagesAPI(senderUsername, chatType) {

  const URL = SPAM_MESSAGES_URL;

  return (dispatch) =>
    ApiService.get(URL, { params: senderUsername, chatType })
      .then((response) => {
        dispatch(getUserMessages(response.data.entries));
        dispatch(getUserMessagesCount(response.data.totalSize));
      })
      .catch((err) => {
        NotificationService.create({
          type: NotificationService.type.TOAST,
          subtype: NotificationService.subtype.ERROR,
          text: `${URL} failed with: ${err}`,
        });
        dispatch(getUserMessages([]));
      });
}
function getSpamMessageScoreAPI(message, chatType) {

  const URL = SPAM_MESSAGES_SCORE_URL;

  return (dispatch) =>
    ApiService.get(URL, { params: { message, chatType } })
      .then((response) => {
        dispatch(getSpamMessageScore(response.data.score));
      })
      .catch((err) => {
        NotificationService.create({
          type: NotificationService.type.TOAST,
          subtype: NotificationService.subtype.ERROR,
          text: `${URL} failed with: ${err}`,
        });
        dispatch(getSpamMessageScore(0));
      });
}

function getSpamMessagesIpSummaryApi(page, size, chatType) {

  const URL = SPAM_MESSAGES_IP_SUMMARY;

  return (dispatch) =>
    ApiService.get(URL, { params: { page, size, chatType } })
      .then((response) => {
        dispatch(getSpamMessagesIpSummary(response.data.entries));
        dispatch(getspamMessageIpSummaryCount(response.data.totalSize));
      })
      .catch((err) => {
        NotificationService.create({
          type: NotificationService.type.TOAST,
          subtype: NotificationService.subtype.ERROR,
          text: `${URL} failed with: ${err}`,
        });
        dispatch(getSpamMessagesIpSummary([]));
      });
}

function getSpamMessageRecipientSummaryApi(page, size, chatType) {

  const URL = SPAM_MESSAGES_RECIPIENT_SUMMARY;

  return (dispatch) =>
    ApiService.get(URL, { params: { page, size, chatType } })
      .then((response) => {
        dispatch(getSpamMessageRecipientSummary(response.data.entries));
        dispatch(getSpamMessageRecipientSummaryCount(response.data.totalSize));
      })
      .catch((err) => {
        NotificationService.create({
          type: NotificationService.type.TOAST,
          subtype: NotificationService.subtype.ERROR,
          text: `${URL} failed with: ${err}`,
        });
        dispatch(getSpamMessageRecipientSummary([]));
      });
}

export const selector = createStructuredSelector({
  approval2257Identities,
  cashOutApprovalAccounts,
  cashoutStatus,
  watchlistIdentities,
  identitiesTotalCounts,
  cashOutApprovalTotalCounts,
  accountDetails,
  isSuperAdmin,
  staffNotes,
  additionalIdentities,
  watchlistTotalCount,
  roster,
  spammers,
  spammersCount,
  spamDetails,
  spamDetailsCount,
  spamMessages,
  spamMessagesCount,
  spamMessageScore,
  userMessages,
  userMessagesCount,
  securityLogIdentities,
  securityLogTablePage,
  securityLogTotalCount,
  spamMessageIpSummary,
  spamMessageIpSummaryCount,
  spamMessageRecipientSummary,
  spamMessageRecipientSummaryCount,
});

export const actionCreators = {
  fetchApproval2257Identities,
  resetApproval2257Identities,
  fetchCashOutApprovalAccounts,
  resetCashOutApprovalAccounts,
  updateOnWatchStatus,
  getAccountDetails,
  updateAccountStatus,
  getWatchlistIdentities,
  fetchSuperAdmin,
  getStaffNotes,
  getAdditionalIdentities,
  getCashoutStatus,
  updateCashoutStatus,
  getIdentitiesTotalCounts,
  getCashOutApprovalTotalCounts,
  getWatchlistTotalCount,
  getRoster,
  releasePerformer,
  getSpammersData,
  getSpamMessagesData,
  getSpamDetailsData,
  getSpamMessageScoreAPI,
  getUserMessagesAPI,
  getSpamMessagesIpSummaryApi,
  getSpamMessageRecipientSummaryApi,
  resetAccountDetails,
  getSecurityLogIdentities,
  deleteSecurityLogIdentity,
};
